import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import FlexBar from './FlexBar';
import FlexItem from './FlexItem';
import FlexPadding from './FlexPadding';

const Logo = styled.img.attrs({
  alt: 'logo',
  src: '/logo.png',
})`
  margin: 5px;
  flex: 0 0 auto;
`;

const SlingOrangeLabel = styled.div`
  display: inline-block;
  float: right;
  color: ${props => props.theme.slingOrange};
  font-size: 1.3em;
  text-transform: uppercase;
  flex: 0 0 auto;
  margin-right: 20px;
`;

const SlingHeader = ({ title }) => (
  <FlexBar applyBackgroundColor>
    <Logo />
    <FlexItem />
    <FlexPadding />
    <SlingOrangeLabel>{title}</SlingOrangeLabel>
  </FlexBar>
);

SlingHeader.propTypes = { title: PropTypes.string };
SlingHeader.defaultProps = { title: 'A La Carte Dashboards' };

export default SlingHeader;
